import { render, staticRenderFns } from "./detailInformationInstantClaim.vue?vue&type=template&id=1c854eec&"
import script from "./detailInformationInstantClaim.vue?vue&type=script&lang=js&"
export * from "./detailInformationInstantClaim.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports